import { linter } from "@codemirror/lint";
import { Compartment, EditorState } from "@codemirror/state";

import { setSyntaxValidationEffect } from "./state.js";

export function createLinter(lintSource, config) {
    const linterConfig = new Compartment();

    return [
        linterConfig.of([]),
        EditorState.transactionExtender.of((transaction) => {
            for (const effect of transaction.effects) {
                if (effect.is(setSyntaxValidationEffect)) {
                    return {
                        effects: linterConfig.reconfigure(effect.value ? linter(lintSource, config) : []),
                    };
                }
            }

            return null;
        }),
    ];
}
